$=jQuery;
function addLoadEvent(func) {
    var oldonload = window.onload;
    if (typeof window.onload != 'function') {
        window.onload = func;
    } else {
        window.onload = function () {
            oldonload();
            func();
        };
    }
}

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper';
import {Navigation,Pagination,Autoplay,} from 'swiper/modules';


const childEls = document.querySelectorAll(".menu__container .grid__item h3");
    const parentContentEl = document.querySelector(".content__container");
    const custonContentEl = document.querySelector(".custom__content");

    childEls.forEach((el) => {
        el.addEventListener("click", (e) => {
            const id = el.getAttribute("data-id");
            const contentEl= parentContentEl.querySelector(`#id-${id}`);

            parentContentEl.querySelectorAll(".custom__content").forEach((content) => {
            content.style.display = "none";
            });
            contentEl.style.display = "block";
        });
    });


gsap.registerPlugin(ScrollTrigger);

jQuery(function ($) {


    // --- SHOWHIDE NAVBAR ---

    var didScroll;
    var lastScrollTop = 0;
    var delta = 120;
    var navbarHeight = 110;
    $(window).scroll(function () {
        didScroll = true;
    });
    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 350);
    function hasScrolled() {
        var st = $(this).scrollTop();
        if (Math.abs(lastScrollTop - st) <= delta)
            return;
        if (st > lastScrollTop && st > navbarHeight) {
            $('.nav-sticky').addClass('nav-up');
        } else {
            if (st + $(window).height() < $(document).height()) {
                $('.nav-sticky').removeClass('nav-up');
            }
        }
        lastScrollTop = st;
    }
    
    // --- NAV ---

    
    $(".nav-burger").click(function () {
        $(".burger").toggleClass("active");
        $(".nav-responsive").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    }); 
    
    $(".nav-active ul.menu > li.menu-item-has-children > a").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        
        var $this = $(this);
        var $parent = $this.parents("li").first();
        
        var $subMenu = $("ul.sub-menu", $parent);
        if($subMenu.is(":visible")) {
            $subMenu.hide();
        } else {
            $(".nav-active ul.menu li ul.sub-menu").hide();
            $subMenu.show();
        } 
    });
    
    $(".page-single article .gallery br").remove();  

    // --- BURGER ANIMATED ---
    
    $('#nav-burger-animated').click(function () {
        $(this).toggleClass('open');
    });

    // --- NOTICE ALERT ---
    
    $(".notice-alert-close").click(function () {
        $(".notice-alert").slideUp();
    });
    
    $(document.body).trigger('wc_fragment_refresh');


     
   
    $(document).ready(function() {
        // Ajoute la classe 'actif' par défaut au premier élément .title (celui avec data-id="1")
        $(".menu__container .grid__item .title[data-id='1']").addClass("actif");

        $("#id-1").show();
    
        // Ajoute un écouteur d'événement à chaque h3 dans le menu
        $(".menu__container .grid__item .title h3").on("click", function() {
            // Récupère l'id du contenu à afficher
            const id = $(this).parent().data("id");
    
            // Retire la classe 'actif' de tous les éléments .title
            $(".menu__container .grid__item .title").removeClass("actif");
    
            // Ajoute la classe 'actif' à l'élément .title correspondant au data-id cliqué
            $(`.menu__container .grid__item .title[data-id='${id}']`).addClass("actif");
    
            // Cache tous les contenus
            $(".custom__content").hide();
    
            // Affiche le contenu sélectionné
            $(`#id-${id}`).show();
        });
    });


    

    
});

    
    

